<template>

  <b-button type="submit" @click="onClick" variant="success" :disabled="busy || disabled">
    <font-awesome-icon :icon="icon" v-if="!busy"/>
    <font-awesome-icon icon="spinner-third" v-if="busy" spin /> {{title}}
  </b-button>

</template>

<script>
export default {
  props: {
    busy: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Save"
    },
    icon: {
      type: String,
      default: "save"
    },
    onClick: {
      type: Function,
      required: true
    }
  }

  /*
  data() {
    return {
      title: String,
      message: String,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      varient: "Success"
    }
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showSuccess(title, message) {
      this.dismissCountDown = this.dismissSecs;
      this.title = title;
      this.message = message;
      this.dismissCountDown = 5;
      this.varient = "Success";
    },
    showError(title, message) {
      this.dismissCountDown = this.dismissSecs;
      this.title = title;
      this.message = message;
      this.dismissCountDown = 20;
      this.varient = "Danger";
    }
  }*/
};
</script>
